import {Range} from '~/common/FabricInvitation/components/Range/Range';
import {useImageRotate} from '~/common/FabricInvitation/EventCreateDesign/components/PhotoEditor/common/useImageRotate';
import {Typography} from '~library/atoms/Typography';

export const RotateControl = ({canvas, processing}) => {
  const {rotationValue, handleRotationChange} = useImageRotate(canvas);

  return (
    <div className="uyo-control-slider-container">
      <Typography variant="list1" className="uyo-control-slider-label">
        Rotate
      </Typography>
      <div className="uyo-control-slider">
        <Range
          min={-180}
          max={180}
          step={30}
          value={rotationValue}
          onChange={handleRotationChange}
          onLocalChange={handleRotationChange}
          hasControls
          hiddenInput
          dataQaId="rotate-slider"
          disabled={processing}
        />
      </div>
    </div>
  );
};
